import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';
import { PessoasService } from '../../../services/pessoa/pessoas.service';
import { LayoutCindiEquilibria } from './layout-cindi-equilibria/layout-cindi-equilibria';
import { LayoutCindiMovia } from './layout-cindi-movia/layout-cindi-movia';

@Component({
  selector: 'app-triagem-cindi',
  imports: [MatExpansionModule, LayoutCindiEquilibria, LayoutCindiMovia],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './triagem-cindi.html',
  styleUrl: './triagem-cindi.scss',
})
export class TriagemCindi implements OnInit {
  pessoaId!: number;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private pessoaService: PessoasService,
  ) {}

  carregouDados = signal(false);
  detalhesTriagemMovIA: WritableSignal<any> = signal(null);
  detalhesTriagemEquilibrIA: WritableSignal<any> = signal(null);

  async ngOnInit(): Promise<void> {
    const id = this.route.snapshot.paramMap.get('id');
    if (!id) return;

    this.pessoaId = +id;

    try {
      const res = await this.pessoaService.detalhesTriagem(this.pessoaId);

      if (res.data.cindiTipo === 'MovIA') {
        this.detalhesTriagemMovIA.set(res.data);
      }

      if (res.data.cindiTipo === 'EquilibrIA') {
        this.detalhesTriagemEquilibrIA.set(res.data);
      }
    } catch (error) {
      console.error('Erro ao carregar detalhes da triagem', error);
    } finally {
      this.carregouDados.set(true);
    }
  }
}
